import type { IJournalEditorBlock } from '@/entities/journal/model/types';

export interface ArticleTextStats {
  wordCount: number;
  articleBody: string;
}

const TAG_REGEX = /<[^>]+>/gm;
const SPACES_REGEX = /[\n\s\r]+/gm;

export const getArticleTextStats = (blocks: IJournalEditorBlock[]): ArticleTextStats => {
  let wordCount = 0;
  let articleBody = '';

  const textBlocks = blocks.filter((block) => block.type !== 'image');

  textBlocks.forEach((block) => {
    const blockText = block.data?.text
      ?.replaceAll(TAG_REGEX, ' ')
      .replaceAll(SPACES_REGEX, ' ');

    if (blockText?.trim()) {
      wordCount += blockText.trim().split(' ').length;
      articleBody += blockText;
    }
  });

  return { wordCount, articleBody };
};
